<template>
    <div>
        <div class="columns">
            <div class="column is-5">
                <search-bar
                    class="search"
                    :onSearch="onSearchGroup1"
                    :placeholder="$t('comece-digitar-para-filtrar')"
                    :onKeyDown="setListOfItems"
                    :disable="disable"
                    :title="groupOneLabel"
                    :tooltipLabel="groupOneInfo"
                />
                <select
                    multiple
                    ref="listLeftInner"
                    v-model="listLeftSelected"
                    :disable="disable"
                >
                    <option
                        v-for="(d, i) in listLeftInnerSearch"
                        :ref="
                            useValidation
                                ? d[attrValidation]
                                    ? 'option'
                                    : 'optionInvalid'
                                : 'option'
                        "
                        :key="i"
                        :value="d.id"
                        :class="
                            useValidation
                                ? !d[attrValidation]
                                    ? 'invalid-row'
                                    : ''
                                : ''
                        "
                    >
                        <span>{{ d[fieldName] }}</span>
                        <span v-if="d[fieldExtraInformation] != ''">
                            {{
                                d[fieldExtraInformation]
                                    ? '(' + d[fieldExtraInformation] + ')'
                                    : ''
                            }}
                        </span>
                    </option>
                </select>
            </div>
            <div class="column is-2 has-text-centered arrows">
                <!--Setas-->
                <button
                    class="column is-full"
                    @click="sendToRight()"
                    :disabled="disable"
                >
                    <em class="fas fa-caret-right"></em>
                </button>
                <button
                    @click="sendAllToRight()"
                    class="column is-full"
                    :disabled="disable"
                >
                    <em class="fas fa-caret-right"></em>
                    <em class="fas fa-caret-right"></em>
                </button>
                <button
                    @click="sendAllToLeft()"
                    class="column is-full"
                    :disabled="disable"
                >
                    <em class="fas fa-caret-left"></em>
                    <em class="fas fa-caret-left"></em>
                </button>
                <button
                    @click="sendToLeft()"
                    class="column is-full"
                    :disabled="disable"
                >
                    <em class="fas fa-caret-left"></em>
                </button>
            </div>
            <div class="column is-5">
                <search-bar
                    class="search"
                    :onSearch="onSearchGroup2"
                    :placeholder="$t('comece-digitar-para-filtrar')"
                    :title="groupTwoLabel"
                    :disable="disable"
                    :tooltipLabel="groupTwoInfo"
                />
                <select
                    multiple
                    ref="listRightInner"
                    v-model="listRightSelected"
                    :disable="disable"
                >
                    <option
                        v-for="(sd, i) in listRightInnerSearch"
                        :key="i"
                        :value="sd.id"
                    >
                        {{ sd[fieldName] }}
                    </option>
                </select>
            </div>
        </div>
        <div
            v-if="hasInvalidRow"
            class="notification is-danger is-light mb-2 p-2"
        >
            {{ insertLegend() }}
            <!-- <router-link :to="{name: r.name_route}"> {{ $t('clique-aqui') }}</router-link> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // Prop que retornar os selcionados, apenas setar o v-model na instacia do componente,
        listRight: {
            type: Array,
            default: () => [],
        },
        // Dados a serem listados no grupo 1
        listLeft: {
            type: Array,
            default: () => [],
        },
        // Informação que será mostrado na listagem, padrão 'nome'
        fieldName: {
            type: String,
            default: 'nome',
        },
        // Aparece ao lado do nome
        fieldExtraInformation: {
            type: String,
            default: '',
        },
        // Nome do atributo que indica o ID referente a informação listada.
        idAttributeName: {
            type: String,
            default: 'id',
        },
        // Label que será exibida em cima do grupo 1
        groupOneLabel: {
            type: String,
            default: 'disponiveis',
        },
        // Info que será exibida em cima do grupo 2
        groupOneInfo: {
            type: String,
            default: null,
        },
        // Label que será exibida em cima do grupo 2
        groupTwoLabel: {
            type: String,
            default: 'selecionados',
        },
        // Info que será exibida em cima do grupo 2
        groupTwoInfo: {
            type: String,
            default: null,
        },
        // Prop para definir se vai usar dicionario ou não
        disableML: {
            type: Boolean,
            default: false,
        },
        // Ativa o uso da validação
        useValidation: {
            type: Boolean,
            default: () => false,
        },
        // Prop para definir o nome da propriedade que será usada na validação
        attrValidation: {
            type: String,
            default: () => '',
        },
        // Prop para definir a legenda que informa o motivo dos valores serem invalidos
        validationLegend: {
            type: String,
            default: () => 'items-em-vermelho-possuem-valores-invalidos',
        },
        disable: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            listLeftSelected: [],
            listLeftInner: [],
            listLeftInnerSearch: [],

            listRightSelected: [],
            listRightInner: [],
            listRightInnerSearch: [],

            hasInvalidRow: false,
        };
    },
    created() {
        this.listLeftInner = this.arrayToStringAndBack(this.listLeft);
        this.onSearchGroup1();
        this.listRightInner = this.arrayToStringAndBack(this.listRight);
        this.onSearchGroup2();
    },

    mounted() {
        this.$nextTick(() => {
            //organizar lista da forma corretamente.
            //this.setListOfItems()
        });
    },
    watch: {
        listLeft: {
            handler() {
                this.listLeftInner = this.arrayToStringAndBack(this.listLeft);
                this.onSearchGroup1();
            },
            deep: true,
        },
        listRight: {
            handler() {
                this.listRightInner = this.arrayToStringAndBack(this.listRight);
                this.onSearchGroup2();
            },
            deep: true,
        },
    },
    methods: {
        //BUSCA LOCAL GRUPO 1
        onSearchGroup1(text = null) {
            if(this.isNull(text)) {
                this.listLeftInnerSearch = [...this.listLeftInner];
            } else {
                this.listLeftInnerSearch = this.listLeftInner.filter(
                    (l) => l[this.fieldName].toLowerCase().includes(text.toLowerCase())
                );
            }
        },
        //BUSCA LOCAL GRUPO 2
        onSearchGroup2(text = null) {
            if(this.isNull(text)) {
                this.listRightInnerSearch = [...this.listRightInner];
            } else {
                this.listRightInnerSearch = this.listRightInner.filter(
                    (l) => l[this.fieldName].toLowerCase().includes(text.toLowerCase())
                );
            }
        },
        //Faz a validação do attValidation caso atribua true para useValidation
        performValidation(obj) {
            return !this.useValidation ? true : obj[this.attrValidation];
        },
        //
        insertLegend() {
            return this.disableML
                ? this.validationLegend
                : this.$t(this.validationLegend);
        },
        //Valida as cada linha do select
        hasInvalidRows() {
            if (this.useValidation) {
                this.listLeftInner.forEach((l) => {
                    if (!this.performValidation(l)) {
                        this.hasInvalidRow = true;
                    }
                });
            }
        },
        setListOfItems() {
            return
            //this.listLeftInner = [...this.listLeftInner]
            if (this.listRightInner != null) {
                this.listRightInner.forEach((c) => {
                    let itemRemove = this.listLeftInner.filter(
                        (l) => l[this.fieldName] == c[this.fieldName]
                    );
                    let indexOfRemove = this.listLeftInner.indexOf(itemRemove[0]);
                    this.listLeftInner.splice(indexOfRemove, 1);
                });
            }
            //verifica se existe linhas invalidas caso a validação esteja ativa
            this.hasInvalidRows();
            //sincroniza item com o pai
        },
        sendToRight() {
            let tempListLeftUndelected = this.listLeftInner.filter(
                (item) => !this.listLeftSelected.includes(item.id)
            );
            let tempListLeftSelected = this.listLeftInner.filter((item) =>
                this.listLeftSelected.includes(item.id)
            );

            this.$emit('changeListRight', [
                ...this.listRightInner,
                ...tempListLeftSelected,
            ]);
            this.$emit('changeListLeft', tempListLeftUndelected);
            this.$emit('movedToListRight', tempListLeftSelected);
        },
        sendAllToRight() {
            this.$emit('changeListRight', [...this.listRightInner, ...this.listLeftInner]);
            this.$emit('changeListLeft', []);
            this.$emit('movedToListRight', [...this.listLeftInnerSearch]);
        },
        sendToLeft() {
            let tempListRightUndelected = this.listRightInner.filter(
                (item) => !this.listRightSelected.includes(item.id)
            );
            let tempListRightSelected = this.listRightInner.filter((item) =>
                this.listRightSelected.includes(item.id)
            );

            this.$emit('changeListLeft', [
                ...this.listLeftInner,
                ...tempListRightSelected,
            ]);
            this.$emit('changeListRight', tempListRightUndelected);
            this.$emit('movedToListLeft', tempListRightSelected);
        },
        sendAllToLeft() {
            this.$emit('changeListLeft', [...this.listLeftInner, ...this.listRightInner]);
            this.$emit('changeListRight', []);
            this.$emit('movedToListLeft', [...this.listRightInnerSearch]);
        },
    },
};
</script>

<style lang="scss" scoped>
.search-wrapper.search {
    margin-bottom: 1rem !important;
}
select {
    border: 1px solid #e1e1e1;
    border-radius: 3px;
    height: calc(60vh - 5vh);
    option {
        padding-left: 0.5rem;
        display: flex;
        flex-direction: row;
    }
    option:hover {
        background: #f3f2f2;
        cursor: pointer;
    }
    option.invalid-row {
        color: $red-alert;
    }

    option:hover,
    option:focus,
    option:active,
    option:checked {
        color: $primary-color;
    }
}
.arrows {
    margin-top: calc(40vh - 25vh);
    button {
        background: transparent !important;
        border: none !important;
        font-size: 2rem !important;
    }
    /*Efeito clique nas setas*/
    button:hover {
        transform: scale(1.3) !important;
    }
    button:focus {
        outline: none !important;
        transform: scale(1) !important;
    }
    button:active {
        transform: scale(1.3) !important;
    }
}

@media (max-width: 760px) {
    .arrows {
        display: flex;
        margin-top: 0;

        /*Efeito clique nas setas*/
        button {
            transform: rotate(90deg) !important;
        }
        button:hover {
            transform: rotate(90deg) !important;
        }
        button:focus {
            transform: rotate(90deg) !important;
        }
        button:active {
            transform: rotate(90deg) !important;
        }
    }
}
</style>